module.exports = __webpack_public_path__ + "omniv2/img/icon-fuel-economy.881c736f.svg";